import React, { useState, useEffect } from 'react';
import { Container, Message, Loader } from 'semantic-ui-react';
import RequestStatusTable from './RequestStatusTable';
import axios from 'axios';

const RequestHistory = ({
    userEmail,
    userRoles,
    userCategories = [],
    userCategoriesSingleTenancy = [],
    userCategoriesMultiTenancy = []
}) => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchRequests = async () => {
        try {
            setLoading(true);
            const response = await axios.get('https://qa-tenantbridge.parablu.com/api/requests', {
                withCredentials: true
            });

            // Filter based on user role
            const filteredRequests = response.data.requests.filter(request => {
                // Show all requests submitted by the user
                if (request.formData?.submittedBy?.toLowerCase() === userEmail.toLowerCase()) {
                    return true;
                }
                return false;
            });

            setRequests(filteredRequests);
            setError(null);
        } catch (err) {
            console.error('Error fetching requests:', err);
            setError('Failed to load requests: ' + (err.response?.data?.message || err.message));
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (userEmail) {
            fetchRequests();
        }
    }, [userEmail]);

    if (loading) return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
            <Loader active inline='centered'>Loading requests...</Loader>
        </div>
    );

    if (error) return <Message negative>{error}</Message>;

    return (
        <Container className="page-fade-in" fluid>
            <RequestStatusTable
                requests={requests}
                onRefresh={fetchRequests}
                userRoles={userRoles}
                userEmail={userEmail}
                userCategories={userCategories}
                userCategoriesSingleTenancy={userCategoriesSingleTenancy}
                userCategoriesMultiTenancy={userCategoriesMultiTenancy}
            />
        </Container>
    );
};

export default RequestHistory;